export const infoUpdateSuccess = 'Successfully updated ';
export const askingPricePlaceholder = 'Listing asking price...';
export const sqLabel = 'SQUARE FOOTAGE';
export const sqPlaceholder = 'Listing square footage...';
export const bedsLabel = 'BEDS';
export const bedsPlaceholder = 'Listing bedroom amount...';
export const bathsLabel = 'BATHS';
export const bathsPlaceholder = 'Listing baths amount...';
export const neighborhoodDescriptionLabel = 'NEIGHBORHOOD DESCRIPTION';
export const neighborhoodDescriptionPlaceholder = 'About neighborhood...';
export const homeDescriptionLabel = 'HOME DESCRIPTION';
export const homeDescriptionPlaceholder = 'About home...';
